import type { Company } from "./Company.js";

export const fathersCompany = {
	cin: "06533604",
	vat: "CZ06533604",
	name: "Father’s Coffee Roastery s.r.o.",
} satisfies Company;
